const zeroPad = num => (num < 10 ? `0${num}` : num);

export default function abbreviateDuration(seconds) {
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  if (h > 0) {
    return [h, zeroPad(m), zeroPad(s)].join(':');
  }
  return [m, zeroPad(s)].join(':');
}
